import { Message } from '@gonfalon/messages/Message';
import { msg } from '@gonfalon/messages/msg';
import { Button, Dialog, Heading, IconButton } from '@launchpad-ui/components';

import type { Shortcut } from '../../types';
import { ShortcutsForm } from '../ShortcutsForm';

import styles from './ShortcutsDialog.module.css';

export function ShortcutsDialog({ shortcutType }: { shortcutType: Shortcut['type'] }) {
  return (
    <Dialog className={styles.dialog}>
      {({ close }) => (
        <>
          <div slot="header" className={styles.header}>
            <Heading slot="title">
              <Message id="shortcuts.saveDialog.heading" />
            </Heading>
            <IconButton aria-label="close" icon="cancel" size="small" variant="minimal" onPress={close} />
          </div>
          <div slot="body">
            <p className={styles.description}>
              <Message id="shortcuts.saveDialog.hint" />
            </p>
            <ShortcutsForm shortcutType={shortcutType} />
          </div>
          <div slot="footer">
            <Button variant="minimal" onPress={close}>
              {msg('shortcuts.saveDialog.cancel')}
            </Button>
            <Button formTarget="shortcut" form="shortcut" variant="primary" type="submit">
              {msg('shortcuts.saveDialog.save')}
            </Button>
          </div>
        </>
      )}
    </Dialog>
  );
}
